var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonetize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 55,
    viewBox: "0 0 47 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xC3\xADcone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.0497 37.6393C30.4305 37.6393 35.6032 32.4666 35.6032 26.0857C35.6032 19.7048 30.4305 14.5321 24.0497 14.5321C17.6688 14.5321 12.4961 19.7048 12.4961 26.0857C12.4961 32.4666 17.6688 37.6393 24.0497 37.6393Z",
    stroke: "#FAF8F8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.2305 28.8105C21.2305 30.3727 22.4839 31.6262 24.0462 31.6262C25.6085 31.6262 26.8619 30.3727 26.8619 28.8105C26.8619 27.2482 25.6085 25.9947 24.0462 25.9947",
    stroke: "#FAF8F8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.8619 23.1792C26.8619 21.6169 25.6085 20.3634 24.0462 20.3634C22.4839 20.3634 21.2305 21.6169 21.2305 23.1792C21.2305 24.7414 22.4839 25.9949 24.0462 25.9949",
    stroke: "#FAF8F8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.0488 18.6196V20.3636",
    stroke: "#FAF8F8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.0488 31.6261V33.37",
    stroke: "#FAF8F8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M24.0488 9.75454V1.03487",
    stroke: "#FAF8F8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M30.5508 9.75492V5.39508",
    stroke: "#FAF8F8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.5801 9.75492V5.39508",
    stroke: "#FAF8F8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M7.95411 38.3908L1.88804 38.2616C1.69746 38.2575 1.53968 38.4087 1.53562 38.5993L1.2289 53.0017C1.22485 53.1923 1.37605 53.35 1.56663 53.3541L7.63269 53.4833C7.82327 53.4873 7.98106 53.3361 7.98512 53.1456L8.29183 38.7432C8.29589 38.5526 8.14469 38.3948 7.95411 38.3908Z",
    stroke: "#FAF8F8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M8.22656 41.4545C12.5501 38.6752 15.3476 39.1475 18.8718 40.4736C20.089 40.9277 21.7421 41.945 23.1772 41.945C24.6123 41.945 26.2836 41.945 29.3354 41.945C31.9877 41.945 33.7498 44.3611 33.9314 46.1414C33.9678 46.541 33.6226 46.8862 33.223 46.868L23.7221 46.5047",
    stroke: "#FAF8F8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M33.6765 45.1421C33.6765 45.1421 39.8711 42.181 41.4152 41.4907C43.0683 40.7641 44.8123 41.3999 45.6661 42.5988C45.8659 42.8895 45.7932 43.2891 45.5026 43.4708C43.3408 44.7969 34.5848 50.2104 30.8608 52.7718C27.8271 54.8427 23.4672 53.5892 23.4672 53.5892C23.4672 53.5892 15.8194 51.373 13.7848 50.8825C11.7502 50.392 9.78825 50.8825 8.24414 52.7536",
    stroke: "#FAF8F8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonetize);
export default __webpack_public_path__ + "static/media/Monetize.b6a15a057fb06144c50b6f7765b89cf6.svg";
export { ForwardRef as ReactComponent };